import(/* webpackMode: "eager" */ "/app/src/app/[lang]/(blank-layout)/(main-layout)/error.tsx");
